/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 */

import React, { useState } from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

/**
 * @function CustomsDocumentsAddButton
 * 
 * @param {Object} props
 * @param {Function} props.setIsCollapsed
 * @param {Boolean} props.isCollapsed
 * @param {Function} props.t
 * @returns {React.Component}
 */
const CustomsDocumentsAddButton = ({ setIsCollapsed, isCollapsed, t }) => {
  return (
    <div className="row">
      <Form.Button
        onClick={(e) => {
          e.preventDefault();
          setIsCollapsed(!isCollapsed);
        }}
        extraClassName="col-g btn btn-info ml-4 mr-4"
        text={`${
          isCollapsed
            ? t('acl.assetsCustomsDocuments.showForm')
            : t('acl.assetsCustomsDocuments.hideForm')
        }`}
      />
    </div>
  );
};

export default translate()(CustomsDocumentsAddButton);


// WEBPACK FOOTER //
// src/components/assets/form_sections/CustomsDocumentsAddButton.js